import { render, staticRenderFns } from "./bh-flow-generator.vue?vue&type=template&id=25785a3c&lang=pug"
import script from "./bh-flow-generator.vue?vue&type=script&lang=ts"
export * from "./bh-flow-generator.vue?vue&type=script&lang=ts"
import style0 from "./bh-flow-generator.vue?vue&type=style&index=0&id=25785a3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
